module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/survive/2_points&rebounds-833aeced5d0cea2b0383fcba19e3b30b.svg";